import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import DashboardControl, { AjaxRemoteService, Extensions } from 'devexpress-dashboard-react';
import { connect } from "react-redux";
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const ViewDxDashboard = (props) => {
  const query = useQuery();
  const rowid = query.get('rowid');
  var accessToken = props.oidc.user.access_token;
  var url = `${window._env_.REACT_APP_APIS}/devexpressDashboard`;
  const getToken = () => {
    return accessToken;
  };
  const dashboardRef = useRef(null);
  useEffect(() => {
    if (dashboardRef.current && rowid) {
      dashboardRef.current.instance().loadDashboard(rowid)
        .done(() => {
          console.log("Dashboard loaded successfully.");
        })
        .fail(() => {
          console.log("Failed to load the dashboard.");
        });
    }
  }, [rowid]);
  return (
    <div style={{ width: "100%", height: "100%", position: 'relative', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
      <DashboardControl style={{ height: '100%' }}
        ref={dashboardRef}
        workingMode='ViewerOnly'
        DataSourceCacheEnabled="false"
        endpoint={url}>
        <AjaxRemoteService
          headers={{
            'Authorization': `Bearer ${getToken()}`
          }}
        />
      </DashboardControl>
    </div>
  );
}
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(ViewDxDashboard); 